export const V1_REQUEST_SEAT_TRADE = 'V1_REQUEST_SEAT_TRADE'

export default data => {
  return {
    type: V1_REQUEST_SEAT_TRADE,
    data,
  }
}
